import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {AuthModule} from '@auth0/auth0-angular';
import {AppComponent} from './app.component';
import {MainComponent} from './main.component';
import {appRoutes} from './app.route';
import {MaskSelectComponent} from './mask-select.component';
import {CoreModule} from './core/core.module';
import {Principal} from './core/auth/principal.service';
import {AuthInterceptor} from './core/auth/auth.interceptor';
import {ConsentInterceptor} from './core/consent/consent.interceptor';
import {ServicesModule} from './shared/services/services.module';
import {SharedComponentsModule} from './shared/components/components.module';
import {RouterExtService} from './core/services/router-ext.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    MaskSelectComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    ServicesModule,
    SharedComponentsModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(
      appRoutes,
      {
        useHash: true
      }
    ),
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.auth0.audience,
        scope: 'openid email offline_access',
      },
      useRefreshTokens: true,
      cacheLocation: 'localstorage',
    }),
  ],
  providers: [
    Principal,
    RouterExtService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ConsentInterceptor, multi: true},
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
